import { MatInputModule } from '@angular/material/input';
import { UserAdminComponent } from './user-admin.component';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserTableComponent } from './user-table/user-table.component';
import { NewUserDataComponent } from './new-user-data/new-user-data.component';
import { MatRadioModule, MatSelectModule, MatProgressSpinnerModule, MatDatepickerModule } from '@angular/material';
import { NewUserConfirmationComponent } from './new-user-confirmation/new-user-confirmation.component';
import { UserAdminService } from './user-admin.service';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatRadioModule,
		MatSelectModule,
		MatProgressSpinnerModule,
		MatDatepickerModule,
		MatInputModule,
		ReactiveFormsModule,
		NgxMaskModule.forRoot()
	],
	declarations: [
		UserAdminComponent,
		UserTableComponent,
		NewUserDataComponent,
		NewUserConfirmationComponent
	],
	providers: [
		UserAdminService
	]
})
export class UserAdminModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/user-admin/user-admin.module.ts